import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import Slider from './components/Slider';
import InfoBlocks from './components/InfoBlocks';
import ClientsSection from './components/ClientsSection';
import PartnersSection from './components/PartnersSection';
import ArticlesSection from './components/ArticlesSection';
import TestimonialsSection from './components/TestimonialsSection';
import Footer from './components/Footer';
import { Routes, Route, useLocation } from 'react-router-dom';
import PartnersPage from './pages/PartnersPage';
import PartnerDetailPage from './pages/PartnerDetailPage';
import AdminPartnersPage from './cms/AdminPartnersPage';
import InsightsPage from './pages/InsightsPage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ConsultationPage from './pages/ConsultationPage';
import ConsultationSuccess from './pages/ConsultationSuccess';

function App() {
  const [isOnHero, setIsOnHero] = useState(true);
  const location = useLocation();
  const onPartnersPage = location.pathname === '/partners';

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const heroHeight = window.innerHeight;
      setIsOnHero(scrollY < heroHeight - 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Header faded={isOnHero && !onPartnersPage} />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Helmet>
                <title>زوپین | مشاوره مدیریت و توسعه سازمانی</title>
                <meta name="description" content="زوپین ارائه‌دهنده خدمات مشاوره مدیریت، توسعه سازمانی، استراتژی کسب‌وکار و مشاورات تخصصی برای شرکت‌ها در مسیر رشد و توسعه پایدار است." />
                <link rel="canonical" href="https://zoopin.co/" />
                <meta property="og:title" content="زوپین | مشاوره مدیریت و توسعه سازمانی" />
                <meta property="og:description" content="خدمات مشاوره تخصصی برای توسعه سازمانی، استراتژی کسب‌وکار و بهبود عملکرد شرکت‌ها" />
                <meta property="og:url" content="https://zoopin.co/" />
                <meta name="twitter:title" content="زوپین | مشاوره مدیریت و توسعه سازمانی" />
                <meta name="twitter:description" content="خدمات مشاوره مدیریت و توسعه سازمانی برای رشد و توسعه پایدار شرکت‌ها" />
              </Helmet>
              <Slider />
              <InfoBlocks />

              <PartnersSection />
              <TestimonialsSection />
              <ArticlesSection />
            </>
          }
        />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/partners/:slug" element={<PartnerDetailPage />} />
        <Route path="/admin/partners" element={<AdminPartnersPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/consultation" element={<ConsultationPage />} />
        <Route path="/consultation/success" element={<ConsultationSuccess />} />

      </Routes>

      <Footer />
    </div>
  );
}

export default App;
